import type { ResourcesConfig } from '@aws-amplify/core';

type NhdConfig = {
  ENV_NAME: string;
  API_ENDPOINT: string;
  ONBOARDING_ENDPOINT: string;
  COGNITO_USER_POOL_ID: string;
  COGNITO_CLIENT_ID: string;
  COGNITO_IDENTITY_POOL_ID: string;
  COGNITO_AUTH_DOMAIN: string;
  COGNITO_DOMAIN: string;
};

let current: NhdConfig | null = null;

function setConfig(newConfig : NhdConfig) {
  current = newConfig;
}

function getAmplifyConfig() : ResourcesConfig {
  if (!current)
    throw new Error("Config not set.");

  return {
    Auth: {
      Cognito: {
        userPoolId: current.COGNITO_USER_POOL_ID,
        userPoolClientId: current.COGNITO_CLIENT_ID,
        identityPoolId: current.COGNITO_IDENTITY_POOL_ID,
        loginWith: {
          oauth: {
            domain: current.COGNITO_AUTH_DOMAIN,
            scopes: ["email", "openid", "aws.cognito.signin.user.admin", "profile"],
            redirectSignIn: [`https://${current.COGNITO_DOMAIN}`],
            redirectSignOut: [`https://${current.COGNITO_DOMAIN}`],
            responseType: "token",
          },
          username: true,
        },
        // Client-side password validation - should match nhd-iac/_modules/iam/nhd-cognito/user-pool/main.tf.
        // Without this, it assumes minLength:8 and anything else wrong shows one backend error at a time.
        passwordFormat: {
          minLength: 12,
          requireLowercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
          requireUppercase: true,
        },
      },
    },
  };
}

enum Endpoint {
  Onboarding,
  Admin,
  BulkImport,
  Dashboard,
  GeneralData,
  HazardManagement,
  HazardSearch,
  StandardReports
}

const endpointOverrides : {[key in Endpoint]?: string} = {
  // [Endpoint.Admin]: "http://localhost:8080",
  // [Endpoint.BulkImport]: "http://localhost:8086",
  // [Endpoint.Dashboard]: "http://localhost:8085",
  // [Endpoint.GeneralData]: "http://localhost:8083",
  // [Endpoint.HazardManagement]: "http://localhost:8084",
  // [Endpoint.HazardSearch]: "http://localhost:8081",
  // [Endpoint.StandardReports]: "http://localhost:8082",
};

function getApiEndpoint(endpoint : Endpoint) : string {
  if (!current)
    throw new Error("Config not set.");

  return endpointOverrides[endpoint] ||
    (endpoint == Endpoint.Onboarding ? current.ONBOARDING_ENDPOINT : current.API_ENDPOINT);
}

function getShortAppName() : string {
  return current?.ENV_NAME == "PRD" ? "NHD" : `NHD ${current?.ENV_NAME}`;
}

function isSsoEnabled() : boolean {
  return current?.ENV_NAME != "DEV";
}

export { setConfig, getAmplifyConfig, getApiEndpoint, Endpoint, getShortAppName, isSsoEnabled, endpointOverrides };
